import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class PwaService {
    private promptEvent: any;

    constructor(private platform: Platform) {}

    public initPwaPrompt(): void {
        // TODO: Skip for users already loged in
        if (this.platform.ANDROID) {
            window.addEventListener('beforeinstallprompt', (event: any) => {
                event.preventDefault();
                this.promptEvent = event;
                this.openPromptComponent('android');
            });
        }
        if (this.platform.IOS) {
            const isInStandaloneMode = 'standalone' in window.navigator && window.navigator['standalone'];
            if (!isInStandaloneMode) {
                this.openPromptComponent('ios');
            }
        }
    }

    private openPromptComponent(mobileType: 'ios' | 'android'): void {
        if (mobileType == 'android') {
            Swal.fire({
                title: 'App Install',
                html: `<p>To install this web app on your device tap the Menu button and then 'Add to Home screen' button</p>`,
                showCloseButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Add to Home screen',
                cancelButtonText: 'Cancel',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-secondary',
                },
            }).then((willContinue) => {
                if (!willContinue.dismiss) {
                    this.promptEvent.prompt();
                }
            });
        } else if (mobileType == 'ios') {
            Swal.fire({
                title: 'App Install',
                html: `<p>To install this web app on your device tap the Menu button and then 'Add to Home screen' button</p>
                        <h6 pb-1>Step 1</h6>
                        <p pb-2><img src="./assets/images/ios-menu-btn.png"></p>
                        <h6 pb-1>Step 2</h6>
                        <p><img src="./assets/images/ios-add-btn.png"></p>`,
                allowEscapeKey: false,
                allowOutsideClick: false,
            });
        }
    }
}
